import { AxiosPromise, AxiosStatic } from "axios";
import {
  TaxResidency,
  CreateTaxResidencyInput,
  UpdateTaxResidencyInput,
} from "../types/taxResidency";

export const createTaxResidency =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (taxResidency: CreateTaxResidencyInput): AxiosPromise<TaxResidency> =>
    await appAxios.post(`${serverURL}/tax-residencies`, taxResidency, {
      withCredentials: true,
    });

export const updateTaxResidency =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (
    taxResidencyId: string,
    taxResidency: UpdateTaxResidencyInput
  ): AxiosPromise<TaxResidency> =>
    await appAxios.put(
      `${serverURL}/tax-residencies/${taxResidencyId}`,
      taxResidency,
      {
        withCredentials: true,
      }
    );

export const deleteTaxResidency =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (taxResidencyId: string): AxiosPromise<void> =>
    await appAxios.delete(`${serverURL}/tax-residencies/${taxResidencyId}`, {
      withCredentials: true,
    });
